import Vue from 'vue';
import store from './store/store';
import VueRouter from 'vue-router';
import App from './App.vue';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import router from './router';
import VueWorker from 'vue-worker';
import '@/scss/main.scss';
import {initPreload} from '@/api/apiServices';
import Router from 'vue-router';

import VueToastr from 'vue-toastr';
import 'core-js/fn/array/flat-map';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';
/* import the fontawesome core */
import {library} from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

/* import specific icons */
import {faArrowLeft, faClock, faPen, faCheck, faTrash, faXmark} from '@fortawesome/free-solid-svg-icons';
// import {faUserSecret as faUserSecretRegular} from '@fortawesome/free-regular-svg-icons';
// import {faUserSecret as faUserSecretBrands} from '@fortawesome/free-brands-svg-icons';

/* add icons to the library */
library.add(faArrowLeft, faClock, faPen, faCheck, faTrash, faXmark);

const JSONfn = require('jsonfn').JSONfn;
window.JSONfn = JSONfn;
Vue.use(Router);
Vue.use(VueToastr, {
    'preventDuplicates': true,
    'preventOpenDuplicates': true,
});

const firebaseConfig = {
    apiKey: 'AIzaSyCyqnXa9pLNJwrH2AlRP_4xjujUJpl9WjQ',
    authDomain: 'skarb-storage.firebaseapp.com',
    databaseURL: 'https://skarb-storage-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'skarb-storage',
    storageBucket: 'skarb-storage.appspot.com',
    messagingSenderId: '843895943647',
    appId: '1:843895943647:web:0e80c75c9037238b7f146a',
};

firebase.initializeApp(firebaseConfig);

import vClickOutside from 'v-click-outside';

window._ = require('lodash');

Vue.use(VueWorker);
Vue.use(vClickOutside);
Vue.use(VueMoment, {
    moment,
});
Vue.use(VueRouter);
Vue.config.productionTip = false;

Vue.component('VInput', require('./components/VInput').default);
Vue.component('VTextArea', require('./components/VTextArea').default);
Vue.component('VSearch', require('./components/VSearch').default);
Vue.component('VDropdownBlock', require('./components/VDropdownBlock').default);
Vue.component('VLineBlock', require('./components/VLineBlock').default);
Vue.component('VButton', require('./components/VButton').default);
Vue.component('VHeader', require('./components/VHeader').default);
Vue.component('VLabel', require('./components/VLabel').default);
Vue.component('VToggle', require('./components/VToggle').default);
Vue.component('VCheckbox', require('./components/VCheckbox').default);
Vue.component('VFilter', require('./components/VFilter').default);
Vue.component('VSelect', require('./components/VSelect').default);
Vue.component('VDateTimePicker', require('./components/VDateTimePicker').default);
Vue.component('VDateTimeSelectPicker', require('./components/VDateTimeSelectPicker').default);
Vue.component('VContainer', require('./components/VContainer').default);
Vue.component('VCombobox', require('./components/VCombobox').default);
Vue.component('VRadioSwitcher', require('./components/VRadioSwitcher').default);
Vue.component('VLabelCombobox', require('./components/VLabelCombobox').default);

Vue.component('font-awesome-icon', FontAwesomeIcon);

function clearStorage() {
    sessionStorage.clear();
}

// const pjson = require('../package.json');
// const checkCache = () => {
//
//     const appVersion = pjson.version;
//     if (localStorage.getItem('appVersion') !== appVersion) {
//         clearStorage();
//     }
//     localStorage.setItem('appVersion', appVersion);
// };

clearStorage();
let localToastr = '';
const initVue = () => {
    let vm;
    const generateVm = () => {
        vm = new Vue({
            router,
            store,
            render: h => h(App),
            created() {

            },
        });
        localToastr = vm.$toastr;
        vm.$toastr.longError = ((title, msg = '') => {
            return vm.$toastr.Add({
                name: 'longError',
                title,
                msg,
                timeout: 120000,
                type: 'error',
            });
        });
    };

    initPreload().then(() => {
        generateVm();
        vm.$mount('#app');
    }).catch(() => {
        const path = window.location.pathname;
        if (['/demo','/signedin','/login','/cli-callback'].includes(path)) {
            generateVm();
            vm.$mount('#app');
        }
    });

};

export const toastr = function () {
    return localToastr;
};

export const eventBus = new Vue();

initVue();



